<template>
	<div class="modal fade" :id="id" tabindex="-1" role="dialog">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
					<h4 v-show="!!title" class="modal-title">{{ title }}</h4>
				</div>
				<div class="modal-body">
					<slot></slot>
				</div>
				<div v-if="$slots.footer" class="modal-footer">
					<slot name="footer"></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	mounted() {
		$(`#${this.id}`).on('show.bs.modal', (e) => {
            this.$emit('showing', e)
        })
		$(`#${this.id}`).on('shown.bs.modal', (e) => {
            this.$emit('shown', e)
        })
		$(`#${this.id}`).on('hidden.bs.modal', e => {
			this.$emit('hidden', e)
		})
	},
	props: {
		id: {
			type: String,
			required: false,
			default: null,
		},
		title: {
			type: String,
			required: false,
			default: null,
		},
	},
}
</script>
